import React from "react";
import { Navigate } from "react-router-dom";

function AdminRoute({ user, children }) {
	return user?.role === Number(process.env.REACT_APP_ADMIN_ROLE) ? children : <Navigate to="/admin/login" />;
}

export default AdminRoute;